import Session from "../session";
const { defer } = rxjs;

export default function connectSession(config) {
  const session = new Session(config);

  return {
    global$: session.global(),
    notifications$: session.notifications$,
    close: () => session.close(),
    suspend: () => session.suspended$.next(true),
    unsuspend: () => session.suspended$.next(false)
  };
}
